export const getValFromEnum = (data: { [key: string]: string | number }) => {
    const resValues: SelectObject[] = [];
    Object.keys(data).forEach((key: string) => {
        resValues.push({
            label: key,
            value: data[key],
        });
    });
    return resValues;
};
